import CustomNavbar from 'components/core/CustomNavbar';
import Footer from 'components/core/Footer';
import { Col, Container, Row } from 'react-bootstrap';
import { FaRegIdBadge } from 'react-icons/fa';
import { FaRegUser, FaUserDoctor } from 'react-icons/fa6';
import { GoGlobe } from 'react-icons/go';
import { MdArrowForward, MdArrowOutward } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import styles from 'styles/styles.module.css';

export default function Home() {
  const history = useHistory();

  // TODO: Adicionar as métricas da clínica
  const metrics = [
    { value: '20+', label: 'Anos de cuidado' },
    { value: '80k+', label: 'Pacientes atendidos' },
    { value: '650k+', label: 'Procedimentos realizados' },
  ];

  const handleVisitSite = () => {
    // eslint-disable-next-line no-undef
    window.open('https://www.prevencormarilia.com.br', '_blank');
  };

  return (
    <div
      className={`${styles.homePageFonts} d-flex flex-column min-vh-100`}
      style={{
        background: 'linear-gradient(180deg, #f7fbff 0%, #f5f7fb 100%)',
      }}
    >
      <CustomNavbar />

      <main className="flex-grow-1 py-4 py-lg-5">
        <section aria-labelledby="home-intro-title">
          <Container className="px-3 px-lg-4 py-2">
            <Row>
              <Col lg={9} xl={8}>
                <p
                  className="text-uppercase mb-3"
                  style={{ fontSize: '0.75rem', letterSpacing: '0.24em', color: '#d30a0a' }}
                >
                  Portal de acesso
                </p>
                <h1 id="home-intro-title" className="display-6 fw-normal mb-3">
                  Centro de Cardiologia em Marília.
                  <br />
                  <span className="d-block fs-3 text-muted mt-2">
                    Seu coração com <span className="text-primary">carinho</span>.
                  </span>
                </h1>

                <dl className="d-flex flex-nowrap justify-content-start gap-3 gap-sm-4 gap-md-5 mt-4 mb-0">
                  {metrics.map((metric) => (
                    <div key={metric.label} className="d-flex flex-column gap-1">
                      <dd className="fs-6 fw-normal mb-0">{metric.value}</dd>
                      <dt
                        className="text-uppercase text-muted fw-light"
                        style={{ fontSize: '0.65rem', letterSpacing: '0.18em' }}
                      >
                        {metric.label}
                      </dt>
                    </div>
                  ))}
                </dl>

                <div className={`mt-4 ${styles.pulseWrap}`} aria-hidden="true">
                  <svg viewBox="0 0 620 56" preserveAspectRatio="none">
                    <line className={styles.pulseBaseline} x1="0" y1="28" x2="620" y2="28" />
                    <path
                      className={styles.pulseLine}
                      d="M0,28 L120,28 L145,28 L160,8 L178,48 L196,14 L214,28 L245,28 L470,28 L488,8 L506,48 L524,14 L542,28 L620,28"
                    />
                  </svg>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section aria-label="portal-options">
          <Container className="px-3 px-lg-4 pt-3 pb-2 pt-lg-3 pb-lg-2">
            <div className={styles.cardGrid}>
              <div className={styles.card} style={{ '--accent': '#1e8f71' }}>
                <div className={styles.cardIcon}>
                  <FaRegUser />
                </div>
                <span className={styles.cardRole}>Paciente</span>
                <p className={styles.cardDesc}>
                  Consulte exames, acompanhe seu histórico e agende retornos.
                </p>
                <button
                  className={`${styles.cardBtn} ${styles.cardBtnGreen}`}
                  type="button"
                  onClick={() => history.push('/paciente/login')}
                >
                  Acessar
                  <MdArrowForward />
                </button>
              </div>

              <div className={styles.card} style={{ '--accent': '#1d5c8a' }}>
                <div className={styles.cardIcon}>
                  <FaUserDoctor />
                </div>
                <span className={styles.cardRole}>Médico</span>
                <p className={styles.cardDesc}>
                  Prontuários, laudos e agenda clínica em um só lugar.
                </p>
                <button
                  className={`${styles.cardBtn} ${styles.cardBtnBlue}`}
                  type="button"
                  onClick={() => history.push('/medico/login')}
                >
                  Acessar
                  <MdArrowForward />
                </button>
              </div>

              <div className={styles.card} style={{ '--accent': '#0fa8b6' }}>
                <div className={styles.cardIcon}>
                  <FaRegIdBadge />
                </div>
                <span className={styles.cardRole}>Funcionário</span>
                <p className={styles.cardDesc}>
                  Recepção, faturamento e gestão administrativa da clínica.
                </p>
                <button
                  className={`${styles.cardBtn} ${styles.cardBtnTeal}`}
                  type="button"
                  onClick={() => history.push('/funcionario/login')}
                >
                  Acessar
                  <MdArrowForward />
                </button>
              </div>

              <div
                className={`${styles.card} ${styles.cardSite}`}
                style={{ '--accent': '#10242a' }}
              >
                <div className={styles.cardIcon}>
                  <GoGlobe />
                </div>
                <span className={styles.cardRole}>Site Prevencor</span>
                <p className={styles.cardDesc}>
                  Conheça a clínica, especialidades e nossos canais de contato.
                </p>
                <button className={styles.cardBtn} type="button" onClick={handleVisitSite}>
                  Visitar site
                  <MdArrowOutward />
                </button>
              </div>
            </div>
          </Container>
        </section>
      </main>

      <Footer />
    </div>
  );
}
